module.exports = __webpack_public_path__ + "static/media/steam.0d3a90fc.svg";